<template>
  <ul class="partnersList">
    <li v-for="(item, index) in contentList" :key="index" class="partnersList__item">
      <img :src="getImageUrl(item.file)" :alt="item.name" class="partnersList__logo" />
      <ul class="partnersList__body">
        <template v-if="item.name === '一般社団法人キャリア協会'">
          <li>
            <a :href="item.links[0].url" target="_blank" rel="noopener">
              {{ item.links[0].link_text }}
            </a>
            {{ item.links[0].after_text }}
            <a :href="item.links[1].url" target="_blank" rel="noopener">
              {{ item.links[1].link_text }}
            </a>
            {{ item.links[1].after_text }}
          </li>
          <!-- slicedIndex + 2: 元の配列のインデックスを再現するため -->
          <li
            v-for="(link, slicedIndex) in item.links.slice(2)"
            :key="`${item.name}-link-${slicedIndex + 2}`"
          >
            {{ link.before_text }}
            <a :href="link.url" target="_blank" rel="noopener">{{ link.link_text }}</a>
            {{ link.after_text }}
          </li>
        </template>
        <li v-for="(link, linkIndex) in item.links" v-else :key="`${item.name}-link-${linkIndex}`">
          {{ link.before_text }}
          <a :href="link.url" target="_blank" rel="noopener">{{ link.link_text }}</a>
          {{ link.after_text }}
        </li>
      </ul>
    </li>
  </ul>
</template>

<script lang="ts">
export default {
  data(): any {
    return {
      contentList: [
        {
          name: 'HonNe',
          file: 'honne_logo_black.webp',
          links: [
            {
              link_text: 'IT/WEBエンジニアやSE向け転職サイトのおすすめ比較【2023年8月最新】',
              url: 'https://exidea.co.jp/blog/job/job-change/engineer-tenshoku/',
              before_text: '',
              after_text: '',
            },
            {
              link_text: 'IT/IT転職エージェントおすすめ20社を徹底比較【2023年8月最新】',
              url: 'https://exidea.co.jp/blog/job/job-change/it-tenshoku-agent/',
              before_text: '',
              after_text: '',
            },
          ],
        },
        {
          name: 'THE NUNOBLOG',
          file: 'the_nunoblog.webp',
          links: [
            {
              link_text: 'IT/社内SE転職ナビの評判は？口コミから特徴・実績・求人情報を評価',
              url: 'https://the-nunoblog.com/se-navi',
              before_text: '',
              after_text: '',
            },
            {
              link_text: 'IT/IT転職エージェントおすすめ比較ランキング21選【口コミ・評判あり】',
              url: 'https://the-nunoblog.com/it-change-agent',
              before_text: '',
              after_text: '',
            },
          ],
        },
        {
          name: 'ミツカル学び',
          file: 'mitsukaru_manabi.webp',
          links: [
            {
              link_text: 'ミツカル学び',
              url: 'https://resemom.jp/manabi',
              before_text: '「',
              after_text: '」で紹介されました。',
            },
            {
              link_text: '社内SE転職ナビの評判は？未経験でも使える？口コミや特徴を徹底調査',
              url: 'https://resemom.jp/manabi/se-navi/',
              before_text: '',
              after_text: '',
            },
            {
              link_text:
                'IT転職エージェントおすすめ比較24選【2023年版】エンジニア向けに各社の違いを解説',
              url: 'https://resemom.jp/manabi/engineer-agent/',
              before_text: '',
              after_text: '',
            },
            {
              link_text:
                'IT転職サイトおすすめ比較29選【2023年版】エンジニアの求人数ランキングや選び方も',
              url: 'https://resemom.jp/manabi/engineer-site/',
              before_text: '',
              after_text: '',
            },
          ],
        },
        {
          name: 'テックゲート',
          file: 'techgate.webp',
          links: [
            {
              link_text: 'IT業界特化！おすすめ転職エージェント｜未経験からでも働ける！',
              url: 'https://tecgate.selva-i.co.jp/blog/1505/',
              before_text: '',
              after_text: '',
            },
          ],
        },
        {
          name: 'HRドクター',
          file: 'hr_doctor.webp',
          links: [
            {
              link_text: '主要な採用サービス35選！新卒・中途それぞれで紹介',
              url: 'https://www.hr-doctor.com/news/recruit/new-recruit/news-23164',
              before_text: '',
              after_text: '',
            },
          ],
        },
        {
          name: 'パラダイムシフト',
          file: 'paradigm_shift.webp',
          links: [
            {
              link_text: 'エンジニアの採用方法を5つ紹介。それぞれのメリット・デメリットは？',
              url: 'https://paradigm-shift.co.jp/column/20/detail',
              before_text: '',
              after_text: '',
            },
          ],
        },
        {
          name: 'アスターリンク',
          file: 'aster_link.webp',
          links: [
            {
              link_text: '社内SEはやめとけと言われる理由とは？きつくて後悔しがちなポイントを解説',
              url: 'https://www.aster-link.co.jp/posts/syanai-se-yametoke/',
              before_text: '',
              after_text: '',
            },
          ],
        },
        {
          name: '転職鉄板ガイド',
          file: 'tenshoku-teppan-guide.webp',
          links: [
            {
              link_text: '社内SEはつらい？楽？実体験から語る社内SE独特の大変さ',
              url: 'https://agent-guide.com/syanai-se-taihen/',
              before_text: '',
              after_text: '',
            },
          ],
        },
        {
          name: '転職アンテナ',
          file: 'tenshoku-antenna.webp',
          links: [
            {
              link_text: '【評判】社内SE転職ナビは実際どうなのか？口コミと評判を調べてみた',
              url: 'https://tenshoku-antenna.com/se-navi-reputation',
              before_text: '',
              after_text: '',
            },
            {
              link_text:
                'IT転職エージェントおすすめ比較ランキング16選！エンジニア向け転職サービスを徹底解説',
              url: 'https://tenshoku-antenna.com/it-engineer-job-change-site-osusume',
              before_text: '',
              after_text: '',
            },
          ],
        },
        {
          name: 'ITエンジニアの畑',
          file: 'engineer_hatake.webp',
          links: [
            {
              link_text: 'ITエンジニアの畑',
              url: 'https://youmanavisions.com/',
              before_text: '「',
              after_text: '」で紹介されました。',
            },
            {
              link_text:
                'SESエンジニアにおすすめの転職エージェント3選。これだけでOK。【登録する時の注意点】',
              url: 'https://youmanavisions.com/career-change/post-160045/',
              before_text: '',
              after_text: '',
            },
          ],
        },
        {
          name: 'CAREEA UP STAGE',
          file: 'career_up_stage.webp',
          links: [
            {
              link_text:
                '転職エージェントおすすめ比較ランキング！人気大手18社の選び方を年代・職種別に一覧で解説',
              url: 'https://asiro.co.jp/media-career/21553/',
              before_text: '',
              after_text: '',
            },
            {
              link_text: 'IT転職エージェントおすすめ比較28選！エンジニア向けに徹底解説',
              url: 'https://asiro.co.jp/media-career/188/',
              before_text: '',
              after_text: '',
            },
            {
              link_text: 'IT業界向けの転職エージェントおすすめ5選｜選び方や活用ポイントを解説',
              url: 'https://asiro.co.jp/media-career/57622/',
              before_text: '',
              after_text: '',
            },
          ],
        },
        {
          name: 'SES転職ライフ',
          file: 'ses_tensyoku_life.webp',
          links: [
            {
              link_text: 'なぜSESからは転職できないのか？実体験から5つの理由と転職対策を解説！',
              url: 'https://ses-job-change.com/ses-job-change-not/',
              before_text: '',
              after_text: '',
            },
          ],
        },
        {
          name: 'freedash',
          file: 'freedash.webp',
          links: [
            {
              link_text: 'フリーダッシュ',
              url: 'https://freedash.jp/',
              before_text: '',
              after_text: 'にて紹介されました',
            },
            {
              link_text: 'IT転職エージェントおすすめ比較ランキング',
              url: 'https://freedash.jp/it-tenshoku-agent/',
              before_text: '',
              after_text: '',
            },
            {
              link_text: '【20代向け】転職エージェント・転職サイトおすすめ比較ランキング14選',
              url: 'https://freedash.jp/tenshoku-agent-20s/',
              before_text: '',
              after_text: '',
            },
            {
              link_text: '【30代向け】転職エージェント・転職サイトおすすめ比較ランキング13選',
              url: 'https://freedash.jp/tenshoku-agent-30s/',
              before_text: '',
              after_text: '',
            },
          ],
        },
        {
          name: 'サクフリブログ',
          file: 'sakufuri.webp',
          links: [
            {
              link_text: '社内SE転職ナビの口コミ・評判はすごい？メリット・デメリットを解説',
              url: 'https://sakufuri.jp/media/se-navi/',
              before_text: '',
              after_text: '',
            },
            {
              link_text: 'SE(システムエンジニア)向け転職エージェント10選｜良質なサイトを厳選',
              url: 'https://sakufuri.jp/media/se-engineer-agent/',
              before_text: '',
              after_text: '',
            },
            {
              link_text: 'インフラエンジニアに強い転職エージェント13選｜未経験OKのサイトも紹介',
              url: 'https://sakufuri.jp/media/infrastructure-engineer-agent/',
              before_text: '',
              after_text: '',
            },
          ],
        },
        {
          name: 'Qiitajob',
          file: 'Qiitajoblogo.webp',
          links: [
            {
              link_text:
                'IT転職エージェントおすすめ比較29選！エンジニア向けに厳選紹介【2025年2月最新】',
              url: 'https://jobs.qiita.com/best-agent-it/',
              before_text: '',
              after_text: '',
            },
            {
              link_text: 'IT転職サイトおすすめ22選比較！エンジニア向けを厳選して紹介【2024年最新】',
              url: 'https://jobs.qiita.com/best-jobchangesite-it/',
              before_text: '',
              after_text: '',
            },
            {
              link_text:
                '20代におすすめの転職エージェント17社を比較！IT業界・未経験転職・20代後半・女性向けサービスを紹介',
              url: 'https://jobs.qiita.com/best-job-change-agent-20s/',
              before_text: '',
              after_text: '',
            },
          ],
        },
        {
          name: '一般社団法人キャリア協会',
          file: 'career_association.webp',
          links: [
            {
              link_text: 'ユニークキャリア株式会社',
              url: 'https://unique-career.co.jp',
              before_text: '',
              after_text: 'が運営する',
            },
            {
              link_text: '「一般社団法人キャリア協会」',
              url: 'https://job.or.jp/',
              before_text: '',
              after_text: 'にて紹介されました。',
            },
            {
              link_text: '社内SE転職ナビの評判とは？9人のリアルな口コミもあわせて解説',
              url: 'https://job.or.jp/synaise-tenshoku-navi-hyoban/',
              before_text: '',
              after_text: '',
            },
            {
              link_text: 'IT転職エージェントおすすめ34選！未経験者・経験者・目的別に比較',
              url: 'https://job.or.jp/ittensyoku-osusume/',
              before_text: '',
              after_text: '',
            },
          ],
        },
      ],
    };
  },
  methods: {
    getImageUrl(filename: string): string {
      return new URL(`../assets/images/partners/${filename}`, import.meta.url).href;
    },
  },
};
</script>

<style lang="scss" scoped>
.partnersList {
  padding: 0;
  &__item {
    border-bottom: 1px solid #ccc;
    padding: 1rem 0.5rem;
  }
  &__body {
    list-style: none;
    display: grid;
    gap: 4px;
    padding-left: 0;
    li a {
      color: #231815;
      &:hover {
        opacity: 0.7;
        transition: opacity 0.3s ease;
      }
    }
  }
  &__logo {
    width: 150px;
    height: 75px;
    object-fit: contain;
  }
  @media screen and (min-width: 768px) {
    &__item {
      display: grid;
      flex-wrap: wrap;
      align-items: start;
      gap: 56px;
      display: grid;
      padding: 1rem 1.5rem;
      grid-template-columns: 150px 1fr;
    }
  }
}
</style>
